export default __webpack_public_path__ + "static/media/icon_billing.10c5302b.svg";